import { render, staticRenderFns } from "./candidate-modal-documents.vue?vue&type=template&id=68a59c68&scoped=true&"
import script from "./candidate-modal-documents.vue?vue&type=script&lang=js&"
export * from "./candidate-modal-documents.vue?vue&type=script&lang=js&"
import style0 from "./candidate-modal-documents.vue?vue&type=style&index=0&id=68a59c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a59c68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a59c68')) {
      api.createRecord('68a59c68', component.options)
    } else {
      api.reload('68a59c68', component.options)
    }
    module.hot.accept("./candidate-modal-documents.vue?vue&type=template&id=68a59c68&scoped=true&", function () {
      api.rerender('68a59c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/candidate-modal-components/candidate-modal-documents.vue"
export default component.exports